export default "__VITE_ASSET__bd98c62e__"